import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const CONVERSATION_FIELDS = `
  id
  status
  createdAt
  lastIncomingAt
  lastIncoming {
    body
    fromPaddleService
    buyerUser {
      id
      fullName
      buyer {
        id
        name
      }
    }
  }
  isPendingResponse
  assignedTo {
    id
    fullName
  }
`

const CONVERSATION_VARIABLES = `
  $assignedToId: ID
  $status: String
`;

const CONVERSATION_ARGUMENTS = `
  assignedToId: $assignedToId
  status: $status
`;

const CONVERSATION_FIELDS_AND_ERRORS = `
  conversation {
    ${CONVERSATION_FIELDS}
  }
  ${ERRORS}
`;

export const CONVERSATIONS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    conversationsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${CONVERSATION_FIELDS}
      }
      count
    }
  }
`;

export const CONVERSATIONS = gql`
  query Conversations($scopes: [String!]) {
    conversations(scopes: $scopes) {
        ${CONVERSATION_FIELDS}
      }
    }
  `;

export const CREATE_CONVERSATION = gql`
  mutation CreateConversation(
    ${CONVERSATION_VARIABLES}
  ) {
    createConversation(
      ${CONVERSATION_ARGUMENTS}
    ) {
      ${CONVERSATION_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_CONVERSATION = gql`
  mutation UpdateConversation(
    $id: ID!
    ${CONVERSATION_VARIABLES}
  ) {
    updateConversation(
      id: $id
      ${CONVERSATION_ARGUMENTS}
    ) {
      ${CONVERSATION_FIELDS_AND_ERRORS}
    }
  }
`;

export const CONVERSATION = gql`
  query Conversation($id: ID!) {
    conversation(id: $id) {
      ${CONVERSATION_FIELDS}
    }
  }
`;

export const HIDE_CONVERSATION = gql`
  mutation HideConversation($id: ID!) {
    hideConversation(id: $id) {
      conversation {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
